import clsx from 'clsx';

const MODULE_NAMES = {
  core: 'MyDocUploads Core',
  conversations: 'MyDocUploads Conversations',
  'secure-drop': 'MyDocUploads Secure Drop',
  sign: 'MyDocUploads Sign',
  flow: 'MyDocUploads Flow',
};

/** Branded module artwork supplied by MyDocUploads. */
export default function ModuleIcon({ slug, variant = 'glyph', className, decorative = false }) {
  const name = MODULE_NAMES[slug];

  return (
    <img
      src={`/module-icons/mydocuploads-${slug}-${variant}.svg`}
      alt={decorative ? '' : `${name} icon`}
      className={clsx('shrink-0 object-contain', className)}
    />
  );
}
